<template>
    <div>
        <b-card no-body class="mb-1">
            <b-overlay :show="loading" opacity="0.2">
                <div class="row p-1">
                    <div class="col-md-3 mb-1 mb-md-0">
                        <b-input-group class="input-group-merge v-table-search-input">
                            <template #prepend>
                                <b-input-group-text >
                                    <feather-icon icon="SearchIcon"></feather-icon>
                                </b-input-group-text>
                            </template>
                            <b-form-input v-model="searchValue" placeholder="Ara..." ></b-form-input>
                        </b-input-group>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <select class="form-control bg-img-none" v-model="eFilter">
                            <option :value="null">Tümü</option>
                            <option :value="true">Başarılar</option>
                            <option :value="false">Hatalılar</option>
                        </select>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0">
                        <button class="btn btn-success" v-on:click="getCalculatedData">Sorgula</button>
                    </div>
                    <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                        <b-dropdown :disabled="acting" text="İşlemler" right variant="primary">
                            <template #button-content>
                                <b-spinner v-if="acting" small/>
                                <template v-else>İşlemler</template>
                            </template>
                            <!-- <b-dropdown-item >
                                <feather-icon icon="SearchIcon" class="mr-50"></feather-icon>
                                Sorgula
                            </b-dropdown-item> -->
                            <b-dropdown-item v-on:click="getData(false,null)">
                                <feather-icon icon="ZapIcon" class="mr-50"></feather-icon>
                                Hesapla
                            </b-dropdown-item>
                            <b-dropdown-item v-on:click="approve">
                                <feather-icon icon="CheckCircleIcon" class="mr-50"></feather-icon>
                                Tüm Maaşları Onayla
                            </b-dropdown-item>
                            <b-dropdown-item v-if="excelPath" v-on:click="downloadExcel">
                                <feather-icon icon="FileIcon" class="mr-50"></feather-icon>
                                Excel İndir
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-sm bordered-header">
                        <thead>
                            <tr>
                                <th class="align-middle text-center">
                                    <feather-icon icon="MoreHorizontalIcon"/>
                                </th>
                                <th class="py-05 w-100">
                                    <div class="d-flex justify-content-between">
                                        <span>Detaylar</span>
                                        <span v-if="c_duration">{{ c_duration }}</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="override">
                                <tr>
                                    <td colspan="2">
                                        <div class="d-flex align-items-center text-danger pl-1 py-50 pr-50 bg-light-warning rounded">
                                            Maaşlar zaten hesaplandı ve onaylandı.
                                            <button class="btn btn-dark btn-sm ml-auto mr-50" v-on:click="$emit('next')">
                                                Hesaplanan Maaşları Gör
                                            </button> 
                                            <v-executer variant="danger" class="btn-sm" :action="getOverrideData" :loading="acting">
                                                Tüm Maaşları Yeniden Hesapla
                                            </v-executer>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else-if="message != null">
                                <tr>
                                    <td colspan="2">
                                        <div class="alert alert-danger mb-0">
                                            <div class="alert-body">
                                                {{ message }}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </template>
                            <template v-else-if="total">
                                <tr v-for="(d,i) in c_items">
                                    <td>
                                        <button :disabled="$safe(d,'SGKJobNotice.Id') != null && currentId == $safe(d,'SGKJobNotice.Id')" v-if="$safe(d,'SGKJobNotice.Id') != null" class="btn btn-xs btn-icon btn-flat-secondary" v-on:click="confirmAndGetData(true,$safe(d,'SGKJobNotice.Id'),$safe(d,'FullName'))">
                                            <b-spinner v-if="currentId == $safe(d,'SGKJobNotice.Id')" small></b-spinner>
                                            <feather-icon v-else icon="ZapIcon"/>
                                        </button>
                                    </td>
                                    <td>
                                        <calculate-salary-process-result-for-luca-detail :row="d"></calculate-salary-process-result-for-luca-detail>
                                    </td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="2" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="mx-75 my-1" v-if="total!='0'">
                    <div class="bg-light border rounded">
                        <div class="d-flex align-items-center p-50">
                            <div class="row justify-content-md-between justify-content-center text-success">
                                <div class="col-auto mb-1 mb-md-0">
                                    <div class="d-flex align-items-center g-50">
                                        <span class="material-icons-outlined" >calculate</span>
                                        <b>TOPLAM: {{total || 0}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mx-75 my-1" v-if="filteredLength > 0">
                    <div class="row justify-content-md-between justify-content-center">
                        <div class="col-auto mb-1 mb-md-0">
                            <div class="d-flex align-items-center text-nowrap">
                                Toplam {{filteredLength || 0}} kayıt arasından
                                <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                    <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                </select>
                                gösteriliyor.
                            </div>
                        </div>
                        <div class="col-auto mb-1 mb-md-0">
                            <b-pagination class="mb-0" v-model="p" :total-rows="(filteredLength || 0)" :per-page="perPage"></b-pagination>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BInputGroupText, BInputGroup, BFormInput,BPagination,BOverlay, BDropdown, BDropdownItem, BSpinner } from 'bootstrap-vue';
import EmployeeOperationsApi from '@/api/employee-operations'
import CalculateSalaryProcessResultForLucaDetail from './CalculateSalaryProcessResultForLucaDetail.vue';
import Additional from '@/utilities/additional'

export default {
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:()=>({})
        },
    },
    components:{
        BCard,
        BInputGroupText,
        BInputGroup, 
        BFormInput,
        BPagination,
        CalculateSalaryProcessResultForLucaDetail,
        BOverlay,
        BDropdown, 
        BDropdownItem,
        BSpinner
    },
    data(){
        return {
            fields:[
                { name:"Durum",component:true,componentOptions:{name:"csp-luca-result-detail/LucaResultDetail"}, thClass:'w-100',tdClass:'p-50'},
            ],
            searchValue:"",
            acting:false,
            total:0,
            p:1,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            serverData:[],
            loading:false,
            override:false,
            message:null,
            excelPath:null,
            duration:null,
            filteredLength:0,
            total:'0',
            eFilter:null,
            currentId:null
        }
    },
    methods:{
        getOverrideData(){
            this.$confirm('Maaşları yeniden hesaplamak istediğinize emin misiniz?','Bu işlem filtrelenmiş personeller için hakediş tutarlarını yeniden hesaplar ve geri alınamaz.').then(c => {
                if(c){
                    this.getData(true,null)
                }
            })
        },
        confirmAndGetData(bool,id,fullName){
            const text = id ? `Bu işlem filtreye göre ${fullName} adlı personel için hakediş tutarlarını hesaplar, geri alınamaz ve uzun sürebilir.` : 'Bu işlem filtrelenmiş personeller için hakediş tutarlarını hesaplar, geri alınamaz ve uzun sürebilir.' 
            this.$confirm('Maaşları hesaplamak istediğinize emin misiniz.',text).then(c => {
                if(c){ this.getData(bool,id) }
            })
        },
        getData(bool,sgkJNId = null){
            if(sgkJNId) this.currentId = sgkJNId
            this.loading = true
            EmployeeOperationsApi.LucaResult.Calculate({
                ...this.filter,
                Override:bool,
                SGKJobNoticeId:sgkJNId,
                PaginateRequest:{
                    Skip:this.p,
                    Take:this.perPage,
                    QueryParam: this.searchValue || null,
                }
            }).then(res => {
                this.override = false
                this.message = null
                this.excelPath = null
                this.duration = null
                if(res.data.Success){
                    this.total = (res.data.Data.Data || []).length
                    this.filteredLength = (res.data.Data.Data || []).length
                    this.total = res.data.Data.TotalAmountStr
                    this.serverData = res.data.Data.Data
                    this.excelPath = res.data.Data.ExcelPath
                    this.duration = res.headers['request-duration']
                }else if(res.data.Message == 'OVERRIDE_REQUIRED'){
                    this.override = true
                }else{
                    this.message = res.data.Message
                }
                this.loading = false
                this.currentId = null
            }).catch(err => {
                this.total = 0
                this.serverData = []
                this.loading = false
                this.currentId = null
            })
        },
        getCalculatedData(){
            this.loading = true
            EmployeeOperationsApi.LucaResult.GetCalculated({
                ...this.filter,
                PaginateRequest:{
                    Skip:this.p,
                    Take:this.perPage,
                    QueryParam: this.searchValue || null,
                }
            }).then(res => {
                this.override = false
                this.message = null
                this.excelPath = null
                this.duration = null
                if(res.data.Success){
                    this.total = (res.data.Data.Data || []).length
                    this.filteredLength = (res.data.Data.Data || []).length
                    this.total = res.data.Data.TotalAmountStr
                    this.serverData = res.data.Data.Data
                    this.excelPath = res.data.Data.ExcelPath
                    this.duration = res.headers['request-duration']
                }else if(res.data.Message == 'OVERRIDE_REQUIRED'){
                    this.override = true
                }else{
                    this.message = res.data.Message
                }
                this.loading = false
            }).catch(err => {
                this.total = 0
                this.serverData = []
                this.loading = false
            })
        },
        approve(){
            this.$confirm('Tüm maaşları onaylamak istediğinize emin misiniz?','Bu işlem tüm personeller için maaşları onaylar ve geri alınamaz.').then(c => {
                if(c){
                    this.acting = true
                    EmployeeOperationsApi.LucaResult.Confirm({
                        ...this.filter,
                        PaginateRequest:{
                            Skip:this.p,
                            Take:this.perPage,
                            QueryParam: this.searchValue || null,
                        }
                    }).then(res => {
                        if(res.data.Success){
                            this.getCalculatedData()
                        }
                        this.$result(res)
                        this.acting = false
                    }).catch(err => {
                        this.$result(null,err)
                        this.acting = false
                    })
                }
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        }
    },
    computed:{
        c_items(){
            const data = this.serverData
                .filter(r => Additional.ToEng(r.FullName).toLowerCase().includes(Additional.ToEng(this.searchValue).toLowerCase()))
                .filter(r => this.eFilter == null ? true : this.eFilter ? r.Success : !r.Success)
            this.filteredLength = (data ||[]).length
            return data.slice((this.p-1)*this.perPage,this.p*this.perPage)
        },
        c_duration(){
            if(this.duration) return Additional.MsToTime(this.duration)
            else return null
        }
    }
}
</script>